import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { links, mixpanel, constants, snowplow } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'

import messages from './messages'
import s from './CompleteSubscriptionModal.scss'

import gatesImage from './images/gates.svg'


class CompleteSubscriptionModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      productsCount: PropTypes.number,
    }),
  }

  static defaultProps = {
    name: constants.modals.CompleteSubscription,
    data: {
      productsCount: 0,
    },
  }

  constructor() {
    super()

    this.actions = ([
      {
        brand: true,
        title: messages.buttonSubscribe,
        to: links.subscribe,
        onClick: this.handleSubscribeClick,
      },
      {
        gray: true,
        title: messages.buttonClose,
        onClick: this.close,
      },
    ])
  }

  componentDidMount() {
    const { data: { productsCount } } = this.props

    snowplow.track(constants.snowplowEvents.subscriptionReminderPopup, {
      productCount: productsCount,
    })
  }

  handleSubscribeClick = () => {
    const { data: { productsCount } } = this.props

    const placement = productsCount === 1 ? 'popup 1' : 'popup 2'

    mixpanel.track(constants.analyticsEvents.queuePopupClick, { placement })
    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, data: { productsCount } } = this.props

    const hasOneProduct = productsCount === 1
    const title         = hasOneProduct ? messages.titleFirst : messages.titleSecond
    const text          = hasOneProduct ? messages.textFirst : messages.textSecond

    return (
      <ModalWithActions
        name={name}
        title={title}
        actions={this.actions}
        onClose={this.close}
      >
        <FormattedHTMLMessage className={s.text} {...text} />
        <img className={s.image} src={gatesImage} alt="" />
      </ModalWithActions>
    )
  }
}


export default CompleteSubscriptionModal
